export const randomNumberInRange = (rangeLow, rangeHigh, increment = 1) =>
   Math.floor(
      (Math.random() * (rangeHigh - rangeLow + increment)) / increment
   ) *
      increment +
   rangeLow;

export const randomNumbersInRange = (numberCount, range) => {
   const numbers = [];
   while (numbers.length < numberCount) {
      const newNumber = randomNumberInRange(range[0], range[1]);
      if (!numbers.includes(newNumber)) {
         numbers.push(newNumber);
      }
   }
   return numbers;
};

export const arrayValuesToObjectKeys = (arr) =>
   arr.reduce((obj, value) => ({ ...obj, [String(value)]: true }), {});

export const calculateIntervalScore = ({
   notes,
   selectedNotes,
   referenceNotes,
}) => {
   const totals = notes.reduce(
      ({ correct, missed, incorrect }, note) => {
         if (selectedNotes[note] && referenceNotes[note]) {
            return { correct: correct + 1, missed, incorrect };
         }
         if (selectedNotes[note]) {
            return { incorrect: incorrect + 1, correct, missed };
         }
         if (referenceNotes[note]) {
            return { missed: missed + 1, correct, incorrect };
         }
         return { correct, incorrect, missed };
      },
      { correct: 0, missed: 0, incorrect: 0 }
   );
   const penalty = Math.max(0, totals.incorrect - totals.missed);
   const points = Math.max(0, totals.correct - penalty);

   return Math.round((points / Object.keys(referenceNotes).length) * 100);
};

export const calculateAverage = (values) => {
   const { total, count } = values.reduce(
      // eslint-disable-next-line no-shadow
      ({ total, count }, currentValue) => ({
         total: total + currentValue,
         count: count + 1,
      }),
      { total: 0, count: 0 }
   );
   return Math.round(total / count);
};
